<template functional>
  <div
    v-if="typeof props.for === 'undefined' || (!props.for || !props.for.length)"
    :class="['Empty', data.class, data.staticClass]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    for: Array,
  },
}
</script>

<style lang="scss">
.Empty {
  background: $white;
  border: 1px dashed $border-color;
  color: $text-color-light;
  font-weight: $semibold;
  letter-spacing: 0.3px;
  margin-bottom: $grid-unit;
  padding: $grid-unit;
  text-align: center;

  > div > .Btn {
    margin-top: 1rem;
  }

  // --- size
  &.sm {
    padding: $grid-unit-half;
  }
}
</style>
